
export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-gray-900 via-gray-800 to-black text-white border-t border-amber-600/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4 bg-gradient-to-r from-amber-400 via-yellow-300 to-amber-400 bg-clip-text text-transparent" style={{ fontFamily: '"Pacifico", serif' }}>
              METAL LINK
            </h3>
            <p className="text-gray-300 mb-4">
              金属加工のお困りごとを解決する<br />
              プロフェッショナル集団
            </p>
            <div className="text-gray-300 text-sm">
              <p>メタルリンク株式会社</p>
              <p>代表取締役:大森孝人</p>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-400">お問い合わせ</h4>
            <div className="text-gray-300 space-y-2">
              <div className="flex items-center">
                <div className="w-5 h-5 flex items-center justify-center mr-3">
                  <i className="ri-mail-line text-amber-400"></i>
                </div>
                <a href="mailto:t_oomori@metal-link.jp" className="text-sm hover:text-amber-400 transition-colors cursor-pointer">
                  t_oomori@metal-link.jp
                </a>
              </div>
              <div className="flex items-center">
                <div className="w-5 h-5 flex items-center justify-center mr-3">
                  <i className="ri-phone-line text-amber-400"></i>
                </div>
                <a href="tel:0949528650" className="text-sm hover:text-amber-400 transition-colors cursor-pointer">
                  0949-52-8650
                </a>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-400">主要サービス</h4>
            <ul className="text-gray-300 text-sm space-y-1">
              <li>鉄・非鉄・鋳物加工</li>
              <li>表面処理・旋盤・MC</li>
              <li>研削・板金・製缶</li>
              <li>溶接・砥石加工</li>
              <li>工場塗装・人材紹介</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-amber-600/30 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 メタルリンク株式会社. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-gray-400 text-sm hover:text-amber-400 transition-colors cursor-pointer mt-2 md:mt-0"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
